<section
  class="bg-myportal-three min-h-[calc(100vh-220px)] bg-top bg-no-repeat"
>
  <div class="mx-auto w-full max-w-7xl p-5 md:px-8">
    @if (loading) {
      <div class="loading-spinner">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
    } @else if (!selectedOrder) {
      <app-table-page
        [orders]="orders"
        [noOrders]="noOrders"
        (selectOrder)="open($event)"
      ></app-table-page>
    } @else {
      <app-view-order
        [order]="selectedOrder"
        [otherSites]="otherSiteServices"
        (selectOrder)="open($event)"
        (back)="goBack()"
      ></app-view-order>
    }
  </div>
</section>
